import React from "react";
import { useWindowDimensions } from "react-native";
import imageUrl from "../../../../utils/imageUrl";
import MarkdownText from "../../../../components/MarkdownText";
import RichText, { HeadlineRichText } from "../../../../components/RichText";
import { SnippetType } from "../../../../components/Snippet";
import { Body } from "../../styles";
import { Container, Cta, Snippet, Snippets, ImgTop, ImgBottom } from "./styles";

const QuizQuestionInterstitial = ({ question, next }) => {
    const { width } = useWindowDimensions();
    const windowWidth = Math.floor(width);
    let img;
    if (question.interstitialSnippets[0].media) {
        img = imageUrl(question.interstitialSnippets[0].media);
        img.uri = `${img.uri}?w=${windowWidth}&fm=jpg`;
    }
    return (
        <Container>
            {question.interstitialSnippets[0].type === SnippetType.Default &&
                img && <ImgTop source={img} resizeMode="cover" />}
            <Snippets>
                {question.interstitialSnippets?.map(snippet => {
                    const { title, titleRich, body, bodyRich } = snippet;
                    const theTitle = titleRich ? (
                        <HeadlineRichText doc={titleRich} />
                    ) : (
                        title
                    );
                    const theBody = bodyRich ? (
                        <RichText doc={bodyRich} />
                    ) : body ? (
                        <MarkdownText>{body}</MarkdownText>
                    ) : null;
                    return (
                        <Snippet key={snippet._id}>
                            <Body type="h8">{theTitle}</Body>
                            {theBody}
                        </Snippet>
                    );
                })}
            </Snippets>
            <Cta
                title={question.interstitialCtaTitle}
                onPress={() => next([{ questionId: question._id }])}
            />
            {question.interstitialSnippets[0].type === SnippetType.Reverse &&
                img && <ImgBottom source={img} resizeMode="contain" />}
        </Container>
    );
};

export default QuizQuestionInterstitial;
